import { useI18n } from '../i18n/index.tsx'
import { trackEvent } from '../lib/analytics'

export function Footer() {
  const { t } = useI18n()

  return (
    <footer className="w-full bg-background border-t border-border mt-auto">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
          <div className="flex items-center gap-4">
            <a href="/privacy" className="hover:text-foreground transition-colors" onClick={() => trackEvent('footer_click', { link: 'privacy' })}>{t('footer.privacy')}</a>
            <a href="mailto:cikastudio@hotmail.com" className="hover:text-foreground transition-colors" onClick={() => trackEvent('footer_click', { link: 'email' })}>{t('footer.email')}</a>
            <a href="/terms" className="hover:text-foreground transition-colors" onClick={() => trackEvent('footer_click', { link: 'terms' })}>{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  )
}